import React, { useState } from "react";
import axios from "axios";
import { INTERVIEW_AI_URL } from "../../system/keys";
import {
  ModalOverlay,
  ModalCard,
  ModalTitle,
  NPSContainer,
  NPSQuestion,
  NPSSubtitle,
  NPSRatingContainer,
  NPSRatingButton,
  NPSLabels,
  NPSCommentArea,
  NPSButtonContainer,
  NPSSubmitButton,
  NPSSkipButton,
} from "./styled";

interface NPSModalProps {
  isOpen: boolean;
  onClose: () => void;
  assistantId: string;
  callId?: string | null;
  hasFeedback?: boolean;
  translations: any;
}

const NPSModal: React.FC<NPSModalProps> = ({
  isOpen,
  onClose,
  assistantId,
  callId,
  hasFeedback,
  translations,
}) => {
  const [npsRating, setNpsRating] = useState<number | null>(null);
  const [npsComment, setNpsComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitNPS = async () => {
    if (!npsRating) return;

    setIsSubmitting(true);
    try {
      await axios.post(
        `${INTERVIEW_AI_URL}/api/v1/call/feedback`,
        {
          assistant_id: assistantId,
          call_id: callId || "",
          rating: npsRating,
          comment: npsComment,
        },
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      handleClose();
    } catch (err) {
      console.error("Error enviando NPS:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setNpsRating(null);
    setNpsComment("");
    onClose();
  };

  if (!isOpen) return null;

  // No mostrar el modal si ya existe feedback
  if (hasFeedback) return null;

  return (
    <ModalOverlay>
      <ModalCard>
        <ModalTitle>{translations.npsModal.title}</ModalTitle>
        <NPSContainer>
          <NPSQuestion>{translations.npsModal.question}</NPSQuestion>
          <NPSSubtitle>{translations.npsModal.subtitle}</NPSSubtitle>

          <NPSLabels>
            <span>{translations.npsModal.labels.veryBad}</span>
            <span>{translations.npsModal.labels.excellent}</span>
          </NPSLabels>

          <NPSRatingContainer>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
              <NPSRatingButton
                key={rating}
                selected={npsRating === rating}
                onClick={() => setNpsRating(rating)}
              >
                {rating}
              </NPSRatingButton>
            ))}
          </NPSRatingContainer>

          <NPSCommentArea
            placeholder={translations.npsModal.placeholder}
            value={npsComment}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              setNpsComment(e.target.value)
            }
          />

          <NPSButtonContainer>
            <NPSSkipButton onClick={handleClose} disabled={isSubmitting}>
              {translations.npsModal.buttons.skip}
            </NPSSkipButton>
            <NPSSubmitButton
              onClick={submitNPS}
              disabled={!npsRating || isSubmitting}
            >
              {isSubmitting
                ? translations.npsModal.buttons.sending
                : translations.npsModal.buttons.submit}
            </NPSSubmitButton>
          </NPSButtonContainer>
        </NPSContainer>
      </ModalCard>
    </ModalOverlay>
  );
};

export default NPSModal;
